import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { OrdersService } from '@lib-services/orders.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { MessageService } from '@lib-services/message.service';
import { MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { LoaderComponent } from '@lib-ui/loader/loader.component';
import { CommonDropdownComponent } from '@lib-ui/common-dropdawn/common-dropdown.component';
import { ProjectSelectorService } from '@lib-services/project-selector.service';
import { CloseButtonComponent } from '@lib-ui/close-button/close-button.component';
import { TimeZoneComponent } from '../../components/time-zone/time-zone.component';
import { TimeZoneService } from '@lib-services/time-zone.service';

@Component({
    selector: 'app-upload-csv',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatButton,
        MatDialogContent,
        LoaderComponent,
        CommonDropdownComponent,
        CloseButtonComponent,
        MatDialogTitle,
        TimeZoneComponent,
    ],
    templateUrl: './upload-csv.component.html',
    styleUrl: './upload-csv.component.scss'
})
export class UploadCsvComponent{
    form;
    readonly dialogRef = inject(MatDialogRef<UploadCsvComponent>);
    readonly projectSelectorService = inject(ProjectSelectorService);
    loading = signal(false);

    constructor(
        private fb: FormBuilder,
        private ordersService: OrdersService,
        // protected companySelectorService: CompanySelectorService,
        protected messageService: MessageService,
        protected timeZoneService: TimeZoneService,

    ) {
        this.form = this.fb.group({
            // company: [null, Validators.required], //TODO добавить компанию для админа когда будет несколько компаний
            projectId: [0, Validators.required],
        });
    }
    uploadFile(fileInput:  HTMLInputElement): void {
        if (!this.form.controls.projectId.value) {
            this.messageService.warningMessage('Заполните обязательные поля!');
            return;
        }

        fileInput.click();
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (!input.files?.length || !this.form.valid) {
            return;
        }

        const file: File = input.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        const projectId = this.form.controls.projectId.value;
        // const companyId = this.form.controls.company.value;

        if (projectId) {
            formData.append('projectId', projectId?.toString());
        }

        formData.append('hoursOffset', this.timeZoneService.currentTimeZone().toString());

        this.loading.set(true);

        // Отправляем файл на сервер
        this.ordersService.uploadOrders(formData).subscribe({
            next: (response) => {
                this.messageService.successMessage(response.message);
                this.dialogRef.close();
            },
            error: (err) => this.messageService.errorMessage(err.error.message || 'Произошла ошибка', true)
        }).add(() => this.loading.set(false));
    }

    get projectControl(): FormControl {
        return this.form.get('projectId') as FormControl;
    }
}
